export const SET_APPOINTMENT_DETAILS = "SET_APPOINTMENT_DETAILS";
export const SET_APPOINTMENT_LOADED = "SET_APPOINTMENT_LOADED";
export const RESET_RESPONSE_APPOINTMENT = "RESET_RESPONSE_APPOINTMENT";
export const FETCH_APPOINTMENT_DETAILS = "FETCH_APPOINTMENT_DETAILS";
